import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { LinkNodeStyle } from "common/components/breadcrumbs/types";
export function template() {
  const selectedIndex = this.attr("breadcrumbs").findIndex((node) => node.style === LinkNodeStyle.Selected);
  const breadcrumbs = this.attr("breadcrumbs").map((node, i) => {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".breadcrumb-node.mp-font-weight-medium", on: {
      click: () => this.helpers.handleNodeClicked(node)
    }, class: {
      "node-link": i < selectedIndex,
      disabled: node.disabled || i > selectedIndex,
      selected: node.style === LinkNodeStyle.Selected
    } }, /* @__PURE__ */ jsx("div", { sel: ".node-index" }, i + 1), /* @__PURE__ */ jsx("div", { sel: ".node-label" }, node.label)), i < this.attr("breadcrumbs").length - 1 && /* @__PURE__ */ jsx(SvgIconEl, { sel: ".caret", attrs: {
      icon: "caret-right"
    } }));
  });
  return /* @__PURE__ */ jsx("div", { sel: ".breadcrumbs", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, breadcrumbs);
}
